import type { Route } from 'vue-router';
import { BrandTypes } from '@/shared/constants';

/**
 * 获取当前域名
 */
export function getCurrentDomain() {
  const { origin } = window.location;

  return `${origin}${process.env.VUE_APP_PREFIX}`;
}

/**
 * 判断是否为Promise对象
 */
export function isPromise<T>(value: unknown): value is Promise<T> {
  return (
    value != null &&
    (typeof value === 'object' || typeof value === 'function') &&
    typeof (value as Promise<T>).then === 'function' &&
    typeof (value as Promise<T>).catch === 'function'
  );
}

/**
 * 设置iframe跳转方式为顶部窗口
 */
export function setJumpToTopWindow(iframe: HTMLIFrameElement) {
  if (iframe == null || iframe.contentWindow == null) {
    return;
  }

  const doc = iframe.contentWindow.document;
  const a = doc.querySelectorAll('a');

  if (a) {
    for (let i = 0, item; (item = a[i++]); ) {
      if (item.href !== null && item.href !== '') {
        item.target = '_top';
      }
    }
  }
}

/**
 * 获取页面标题
 */
export function getTitle(route: Route): string {
  if (route.meta?.title) {
    return route.meta.title;
  }

  return (route.query.brand as string)?.toUpperCase() === 'YRXD' ? BrandTypes.YRXD : BrandTypes.YXH;
}
